/*
  RevoRope — controlador del mega-menú del header (escritorio).
  Accesible: los botones llevan aria-expanded / aria-controls; abren con click o
  Enter/Espacio; Escape cierra y devuelve el foco al botón; click fuera cierra; en
  escritorio (puntero fino) también abre al pasar el ratón. En móvil el nav de
  escritorio está oculto y se usa el <details> accordion nativo, así que este script
  solo gobierna el mega-menú de escritorio.
*/
(function () {
  'use strict';

  var nav = document.querySelector('[data-rr-nav]');
  if (!nav) return;

  var items = Array.prototype.slice.call(nav.querySelectorAll('[data-rr-hasmega]'));
  if (!items.length) return;

  var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var closeTimer = null;

  function panelFor(item) {
    return item.querySelector('[data-rr-megapanel]');
  }
  function btnFor(item) {
    return item.querySelector('[data-rr-megabtn]');
  }

  function close(item) {
    var btn = btnFor(item);
    var panel = panelFor(item);
    if (!btn || !panel) return;
    btn.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    item.classList.remove('is-open');
  }

  function open(item) {
    items.forEach(function (other) {
      if (other !== item) close(other);
    });
    var btn = btnFor(item);
    var panel = panelFor(item);
    if (!btn || !panel) return;
    btn.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    item.classList.add('is-open');
  }

  function closeAll() {
    items.forEach(close);
  }

  items.forEach(function (item) {
    var btn = btnFor(item);
    var panel = panelFor(item);
    if (!btn || !panel) return;

    close(item);

    btn.addEventListener('click', function () {
      // En dispositivos con hover, el ratón ya puede haber abierto el panel al
      // entrar (mouseenter); si click alternara a "cerrar" aquí, el gesto normal
      // de "pasar el ratón y luego pulsar" cerraría lo que el propio usuario acaba
      // de abrir. Cerrar ya lo cubren mouseleave/Escape/click-fuera, así que en
      // hover click solo abre (nunca alterna a cerrado).
      if (hoverCapable) {
        open(item);
      } else if (btn.getAttribute('aria-expanded') === 'true') {
        close(item);
      } else {
        open(item);
      }
    });

    if (hoverCapable) {
      item.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        open(item);
      });
      item.addEventListener('mouseleave', function () {
        closeTimer = window.setTimeout(function () {
          close(item);
        }, 140);
      });
    }
  });

  // Escape cierra y devuelve el foco al botón abierto.
  nav.addEventListener('keydown', function (evento) {
    if (evento.key !== 'Escape') return;
    var abierto = items.filter(function (item) {
      return item.classList.contains('is-open');
    })[0];
    if (abierto) {
      close(abierto);
      var btn = btnFor(abierto);
      if (btn) btn.focus();
    }
  });

  // Click fuera del nav cierra todo.
  document.addEventListener('click', function (evento) {
    if (!nav.contains(evento.target)) closeAll();
  });

  // Al salir el foco del panel abierto (Tab), cerrar — comprobar contra el item
  // abierto en concreto, no contra el <nav> entero: si no, tabular del último enlace
  // del panel al siguiente botón/enlace del propio nav lo deja abierto de fondo.
  document.addEventListener('focusin', function (evento) {
    var abierto = items.filter(function (item) {
      return item.classList.contains('is-open');
    })[0];
    if (abierto && !abierto.contains(evento.target)) close(abierto);
  });
})();

/*
  RevoRope — menú móvil a PANTALLA COMPLETA (overlay).
  Se abre desde el hamburger, se cierra con la X, Escape, clic en el fondo o
  deslizando el panel a la derecha (swipe to dismiss). El foco queda ATRAPADO dentro
  del panel mientras está abierto y vuelve al hamburger al cerrar. aria-expanded del
  botón refleja el estado. Bloquea el scroll de fondo. Respeta prefers-reduced-motion.
*/
(function () {
  'use strict';

  var toggle = document.querySelector('[data-rr-mobtoggle]');
  var overlay = document.querySelector('[data-rr-mobmenu]');
  if (!toggle || !overlay) return;

  var panel = overlay.querySelector('[data-rr-mobpanel]');
  var closeBtn = overlay.querySelector('[data-rr-mobclose]');
  if (!panel) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var CERRAR_MS = 340;
  var abierto = false;
  var hideTimer = null;

  var FOCO = 'a[href], button:not([disabled]), summary, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function focusables() {
    return Array.prototype.slice.call(panel.querySelectorAll(FOCO)).filter(function (el) {
      // Sólo visibles/enfocables: los enlaces dentro de un <details> cerrado no
      // se renderizan, así que no cuentan (getClientRects vacío).
      return el.getClientRects().length > 0;
    });
  }

  function onKeydown(evento) {
    if (evento.key === 'Escape') {
      evento.preventDefault();
      cerrar();
      return;
    }
    if (evento.key !== 'Tab') return;
    var lista = focusables();
    if (!lista.length) return;
    var primero = lista[0];
    var ultimo = lista[lista.length - 1];
    if (evento.shiftKey && document.activeElement === primero) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault();
      primero.focus();
    } else if (!panel.contains(document.activeElement)) {
      evento.preventDefault();
      primero.focus();
    }
  }

  function abrir() {
    if (abierto) return;
    abierto = true;
    window.clearTimeout(hideTimer);
    overlay.hidden = false;
    // Forzar reflow para que la transición de entrada se dispare.
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    document.documentElement.classList.add('rr-noscroll');
    toggle.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', onKeydown, true);
    if (closeBtn) closeBtn.focus();
  }

  function cerrar() {
    if (!abierto) return;
    abierto = false;
    panel.classList.remove('is-dragging');
    overlay.classList.remove('is-open');
    // Limpiar restos de arrastre para que las reglas CSS animen la salida.
    panel.style.transform = '';
    overlay.style.background = '';
    document.documentElement.classList.remove('rr-noscroll');
    toggle.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onKeydown, true);
    var ms = reduce.matches ? 0 : CERRAR_MS;
    hideTimer = window.setTimeout(function () {
      overlay.hidden = true;
    }, ms);
    toggle.focus();
  }

  toggle.addEventListener('click', abrir);
  if (closeBtn) closeBtn.addEventListener('click', cerrar);

  // Clic en el fondo (fuera del panel) cierra. Con el panel a ancho completo esto
  // sólo ocurre a mitad de un arrastre, pero se cubre por robustez.
  overlay.addEventListener('click', function (evento) {
    if (evento.target === overlay) cerrar();
  });

  // Al pulsar un enlace real del menú, cerrar (la navegación ocurre igualmente;
  // en anclas de la misma página deja el overlay cerrado). No cierra en <summary>.
  panel.addEventListener('click', function (evento) {
    var enlace = evento.target.closest('a[href]');
    if (enlace && panel.contains(enlace)) cerrar();
  });

  // ---- Swipe to dismiss: arrastrar el panel a la derecha lo cierra ----
  var startX = 0;
  var startY = 0;
  var dx = 0;
  var arrastrando = false;
  var decidido = false;
  var ancho = 1;

  function onTouchStart(evento) {
    if (!abierto || evento.touches.length !== 1) return;
    startX = evento.touches[0].clientX;
    startY = evento.touches[0].clientY;
    dx = 0;
    arrastrando = false;
    decidido = false;
    ancho = panel.offsetWidth || window.innerWidth || 1;
  }

  function onTouchMove(evento) {
    if (!abierto || evento.touches.length !== 1) return;
    var cx = evento.touches[0].clientX;
    var cy = evento.touches[0].clientY;
    var ddx = cx - startX;
    var ddy = cy - startY;

    if (!decidido) {
      if (Math.abs(ddx) < 8 && Math.abs(ddy) < 8) return;
      decidido = true;
      // Sólo tratamos como swipe si el gesto es claramente horizontal; si es
      // vertical, dejamos que el contenido del menú haga scroll normal.
      arrastrando = Math.abs(ddx) > Math.abs(ddy);
      if (arrastrando) panel.classList.add('is-dragging');
    }
    if (!arrastrando) return;

    dx = Math.max(0, ddx); // sólo hacia la derecha
    evento.preventDefault();
    panel.style.transform = 'translateX(' + dx + 'px)';
    var frac = Math.min(1, dx / ancho);
    overlay.style.background = 'rgba(10, 10, 10, ' + (0.55 * (1 - frac)).toFixed(3) + ')';
  }

  function onTouchEnd() {
    if (!arrastrando) return;
    panel.classList.remove('is-dragging');
    var umbral = Math.min(120, ancho * 0.3);
    if (dx > umbral) {
      cerrar(); // limpia el transform y anima la salida
    } else {
      // Volver a su sitio (la transición vuelve translateX a 0).
      panel.style.transform = '';
      overlay.style.background = '';
    }
    arrastrando = false;
    decidido = false;
    dx = 0;
  }

  panel.addEventListener('touchstart', onTouchStart, { passive: true });
  panel.addEventListener('touchmove', onTouchMove, { passive: false });
  panel.addEventListener('touchend', onTouchEnd, { passive: true });
  panel.addEventListener('touchcancel', onTouchEnd, { passive: true });

  // Si se pasa a escritorio con el menú abierto (rotación/resize), cerrarlo limpio.
  window.addEventListener('resize', function () {
    if (abierto && window.matchMedia('(min-width: 901px)').matches) cerrar();
  });
})();
